import { type FunctionComponent, type SVGAttributes } from 'react';

import CreateNewOrganization from './createNewOrganization.svg';

const illustrations: Record<
  string,
  FunctionComponent<SVGAttributes<SVGElement>>
> = {
  'create-new-organization': CreateNewOrganization,
};

export default illustrations;
